import React from 'react'
import { useTranslation } from 'react-i18next'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { usePage } from 'client/store'
import { setEditingEntity } from 'client/store/management/managementActions'
import { SettingsMenuButton } from 'src/editor/shared/components/settings-menu-button'
import { findEntityByType } from 'common/utils/entityUtils'
import { setActiveSidebarTab } from 'client/actions/actionsManagement'
import { useSidebarVisibilityActionsContext } from 'client/context/SidebarVisibilityContext'
import { GroupTitle } from './settings/group-title'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import {
  getWebsiteLocale,
  getWebsiteName,
  getWebsiteLocales,
} from 'src/editor/store/website-settings/website-settings-selector'
import { useWebsiteSettings } from 'client/store'
import {
  // setWebsiteLocales,
  // setWebsiteLocale,
  setWebsiteName,
} from 'src/editor/store/website-settings/website-settings-actions'
import { useAppDispatch } from 'client/hooks/use-dispatch'
// import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
// import { LanguageSelector } from 'src/editor/shared/ui-lib/language-selector'

export const WebsiteSettings = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { showSidebar } = useSidebarVisibilityActionsContext()

  const websiteName = useWebsiteSettings(getWebsiteName)
  const websiteLocale = useWebsiteSettings(getWebsiteLocale)
  const websiteLocales = useWebsiteSettings(getWebsiteLocales)

  const websiteLogoEntity = usePage(page =>
    findEntityByType(page.entities, EntityTypeEnum.WebsiteLogo),
  )

  const onOpenLogoSettings = () => {
    if (websiteLogoEntity) {
      // TODO: make sure it works
      dispatch(setEditingEntity(websiteLogoEntity.id))
    } else {
      // TODO: create website logo entity?
    }
    setActiveSidebarTab(null)
    showSidebar()
  }

  return (
    <>
      <span className="mb-6 block text-heading-4">
        {t('website_settings.sidebar.title')}
      </span>

      <TextInputControl
        value={websiteName || ''}
        update={value => {
          dispatch(setWebsiteName(value))
        }}
        wrapperProps={{
          className: 'mb-6',
          labelText: t('website_settings.sidebar.website_name.label'),
          required: true,
        }}
      />

      {/* TODO: add back when we have a way to set the website languages */}
      {/* 
      <LanguageSelector
        isMulti={false}
        selectedLanguages={websiteLocale}
        onChange={value => {
          dispatch(setWebsiteLocale(value as PageLocaleEnum))
        }}
        labelText={t('website_settings.sidebar.main_language.label')}
        required
      />

      <GroupTitle withoutHorizontalLine>
        website_settings.sidebar.website_languages.label
      </GroupTitle>

      <LanguageSelector
        isMulti
        selectedLanguages={websiteLocales}
        onChange={value => {
          dispatch(setWebsiteLocales(value as PageLocaleEnum[]))
        }}
        labelText={t('website_settings.sidebar.website_languages.description')}
      /> */}

      <GroupTitle withoutHorizontalLine className="mb-2">
        website_settings.sidebar.logo.label
      </GroupTitle>
      <SettingsMenuButton onClick={onOpenLogoSettings}>
        {t('website_settings.sidebar.logo.nested_menu_title')}
      </SettingsMenuButton>
    </>
  )
}
